import { useI18n } from "../i18n";
import { toast } from "sonner";
import { Crown } from "lucide-react";
import { api } from "../lib/api";
import { useAuth } from "../context/AuthContext";


export const SubscriptionCard = () => {
  const { t, date } = useI18n();
  const { user, setUser } = useAuth();
  const s = user?.subscription;
  if (!s?.active) return null;

  const cancel = async () => {
    try {
      const r = await api.post("/subscription/cancel");
      if (r.data.manage_url) { window.open(r.data.manage_url, "_blank", "noopener,noreferrer"); toast(t("cancelPaypal")); return; }
      setUser(r.data);
      toast(t("cancelled"));
    } catch (e) { toast.error(e.response?.data?.detail || t("payError")); }
  };

  return (
    <div className="panel p-6 sm:p-8 grid sm:grid-cols-[1fr_auto] gap-6 items-center trial-card" data-testid="subscription-card">
      <div className="grid gap-2">
        <span className="label text-amber flex items-center gap-2"><Crown size={13} /> {t("subTitle")}</span>
        <p className="text-sm text-muted">{t("subDesc")}</p>
        <p className="text-sm text-muted">{t("subReset", { date: date(s.credits_reset_at) })} · {t(s.status === "active" ? "subRenew" : "subUntil", { date: date(s.paid_until) })}</p>
        {s.status === "active" && <button className="font-mono text-xs text-subtle underline justify-self-start" onClick={cancel} data-testid="subscription-cancel-btn">{t("cancelRenew")}</button>}
      </div>
      <div className="text-right">
        <p className="font-mono font-black text-5xl text-amber glow-amber" data-testid="subscription-credits-left">{s.credits_left}</p>
        <p className="label">{t("creditsThisMonth")}</p>
      </div>
    </div>
  );
};
